import { lazy, Suspense } from "react";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import SampleQuotes from "@/components/landing/SampleQuotes";
import PanelHomeCard from "@/components/panel/PanelHomeCard";

// Below-fold sections — lazy-loaded so the initial landing-page JS chunk
// stays small. Users see Hero + HowItWorks immediately; the rest streams in.
const SampleGallery = lazy(() => import("@/components/landing/SampleGallery"));
const Testimonials = lazy(() => import("@/components/landing/Testimonials"));
const PricingPreview = lazy(() => import("@/components/landing/PricingPreview"));
const FinalCTA = lazy(() => import("@/components/landing/FinalCTA"));

// Sized fallback so the page doesn't jump as each section streams in.
function BelowFoldFallback({ minH = "min-h-[400px]" }) {
  return <div className={minH} aria-hidden="true" />;
}

export default function Landing() {
  return (
    <div className="relative">
      <Hero />
      {/* Panel home card: the flagship showcase — larger portraits, per-panelist
          share buttons, and deep links to /panel#{id}. Each face is its own
          shareable social-media asset with a stable anchor URL. */}
      <section
        className="max-w-6xl mx-auto px-6 md:px-10 pt-10 md:pt-14"
        data-testid="landing-panel-home-card-section"
      >
        <PanelHomeCard />
      </section>
      <HowItWorks />
      <SampleQuotes />
      <Suspense fallback={<BelowFoldFallback />}>
        <SampleGallery />
      </Suspense>
      <Suspense fallback={<BelowFoldFallback />}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<BelowFoldFallback />}>
        <PricingPreview />
      </Suspense>
      <Suspense fallback={<BelowFoldFallback minH="min-h-[300px]" />}>
        <FinalCTA />
      </Suspense>
    </div>
  );
}
